import { render, staticRenderFns } from "./StandardSection.vue?vue&type=template&id=fdd2a1ba&scoped=true&"
import script from "./StandardSection.vue?vue&type=script&lang=js&"
export * from "./StandardSection.vue?vue&type=script&lang=js&"
import style0 from "./StandardSection.vue?vue&type=style&index=0&id=fdd2a1ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd2a1ba",
  null
  
)

export default component.exports